// src/pages/products/ProductForm.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../utils/config';

export default function ProductForm({ product, onSuccess, onCancel }) {
  const [name, setName] = useState(product?.name || '');
  const [category_id, setCategoryId] = useState(product?.category_id || '');
  const [hsn_code, setHsnCode] = useState(product?.hsn_code || '');
  const [price, setPrice] = useState(product?.price || '');
  const [stock, setStock] = useState(product?.stock || '');
const [gst_category_id, setGstCategoryId] = useState(product?.gst_category_id || '');

  const [categories, setCategories] = useState([]);
    const [gstCategories, setGstCategories] = useState([]);

  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchCategories = async () => {
      const res = await axios.get(`${API_BASE_URL}/api/categories`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCategories(res.data);
    };

    const fetchGSTCategories = async () => {
    const res = await axios.get(`${API_BASE_URL}/api/gst-categories`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setGstCategories(res.data);
  };

  fetchCategories();
  fetchGSTCategories();

  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { name, category_id, hsn_code, price, stock,  gst_category_id
 };

    try {
      if (product) {
        await axios.put(`${API_BASE_URL}/api/products/${product.id}`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        await axios.post(`${API_BASE_URL}/api/products`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }
      onSuccess();
    } catch (err) {
      console.error('Save error:', err.message);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mb-4 grid grid-cols-2 gap-4">
      <input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Product Name"
        className="border px-3 py-2 rounded"
        required
      />

      <select
        value={category_id}
        onChange={(e) => setCategoryId(e.target.value)}
        className="border px-3 py-2 rounded"
        required
      >
        <option value="">Select Category</option>
        {categories.map((cat) => (
          <option key={cat.id} value={cat.id}>
            {cat.name}
          </option>
        ))}
      </select>
<div>
  <label className="block text-sm font-medium">GST Category</label>
  <select
    value={gst_category_id}
    onChange={(e) => setGstCategoryId(e.target.value)}
    className="w-full border px-3 py-2 rounded"
    required
  >
    <option value="">Select GST Category</option>
    {gstCategories.map((cat) => (
      <option key={cat.id} value={cat.id}>
        {cat.name} ({cat.gst_percent}%)
      </option>
    ))}
  </select>
</div>


      <input
        value={hsn_code}
        onChange={(e) => setHsnCode(e.target.value)}
        placeholder="HSN Code"
        className="border px-3 py-2 rounded"
      />

      <input
        type="number"
        value={price}
        onChange={(e) => setPrice(e.target.value)}
        placeholder="Price"
        className="border px-3 py-2 rounded"
        required
      />

      <input
        type="number"
        value={stock}
        onChange={(e) => setStock(e.target.value)}
        placeholder="Stock"
        className="border px-3 py-2 rounded"
        required
      />

      <div className="col-span-2 mt-2">
        <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded mr-2">
          {product ? 'Update' : 'Add'}
        </button>
        <button onClick={onCancel} type="button" className="text-gray-600 underline">
          Cancel
        </button>
      </div>
    </form>
  );
}
